import React from 'react'

import { Link } from 'react-router-dom'

// image
// when no image
import noImgFoundImg from 'assets/images/no-img.png'

export default function SearchItem(props) {
    // props
    const { dataItem, searchResultsImage, handleSearchModalClose } = props

    return (
        <div className="search-item">
            <Link to={`/product/${dataItem.product_url}?id=${dataItem.product_id}`} className="si-inner d-flex align-items-center text-decoration-none st-text-primary" onClick={() => handleSearchModalClose()}>
                {/* img */}
                <div className="img-sec">
                    <img 
                        src={searchResultsImage[dataItem.product_id]?.main_thumb?.small || noImgFoundImg} 
                        height={60}
                        width={60}
                        alt="product-img"
                        className="img-fluid" />
                </div>

                {/* text */}
                <div className="text-sec media-body st-fs-16 d-flex">
                    <p className="name mb-0">{dataItem.product_name}</p>
                    <p className="price ms-auto ps-2 mb-0">${dataItem.price.toFixed(2)}</p>
                </div>
            </Link>
        </div>
    )
}
